import React, { useEffect } from "react";
import Banner from "../Common_Component/Banner/Banner";
import Below_Banner_section from "../Common_Component/Below_Banner_section/Below_Banner_section";
import Get_Started_Today from "./Get_Started_Today/Get_Started_Today";
import Your_Branch from "./Your_Branch/Your_Branch";
import Services from "./Services/Services";
import Why_Partner_with_Us from "./Why_Partner_with_Us/Why_Partner_with_Us";
import Looking_for_support from "./Looking_for_support/Looking_for_support";
import Sector_We_Serve from "./Sector_We_Serve/Sector_We_Serve";
import Inquire_Now from "./Inquire_Now/Inquire_Now";

function Home() {
  const [modalShow, setModalShow] = React.useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <>
      <Banner videoSrc={"/Assets/Vedio/Home/new_vdo_360.mp4"} />
      <Below_Banner_section
        headingText={"Welcome to ReachOut Media Tech Pvt. Ltd."}
        ContentText={
          "Your Complete Advertising Partner! At ReachOut Media Tech Pvt. Ltd., we offer a comprehensive range of advertising solutions, from innovative digital screens to print and digital marketing services, as well as high-quality printing for your branding materials. Our mission is to help brands connect with audiences in both urban and rural Maharashtra, using a multi-channel approach that ensures maximum visibility & impact. Whether it’s dynamic digital ads at Videowala Bus stand, targeted print media campaigns, or effective digital marketing, we provide the right tools to drive your brand’s success."
        }
      />
      <Get_Started_Today />
      <Your_Branch />
      <Services />
      <Looking_for_support />
      <Why_Partner_with_Us />
      <Sector_We_Serve />
      <Inquire_Now />
    </>
  );
}

export default Home;
